export const queryAllResidentData = `
  id
  deletedAt
  name {
    firstFull
    last
    gender
    birthName
    title
  }
  identifier
  alternativeIndicatorNumber
  residentBaseData {
    personalData {
      placeOfBirth
      dateOfBirth
      confession
      nationality
      maritalStatus
      numberOfChildren
    }
    currentAddress {
      city
      street
      number
      zipCode
    }
    communication {
      phone
      mobilePhone
      email
    }
    oldAddress {
      city
      street
      number
      zipCode
    }
    healthInsurance {
      number
      insurance {
        id
        name
      }
    }
    remark
  }
`;

export const queryResidentMenuData = `
    id
    deletedAt
    isActive
    isAbsent
    isApplicant
    name {
      firstFull
      last
      gender
      title
    }
    identifier
    alternativeIndicatorNumber
    bed {
      id
      label
    }
    residentBaseData {
      personalData {
        dateOfBirth
      }
    }
    profilePictureUrl
`;

export const queryResidentNameAndId = `
    id
    name {
      firstFull
      last
      title
    }
`;

export const queryResidentAddress = `
  id
  name {
    firstFull
    last
    title
  }
  residentBaseData {
    currentAddress {
      city
      street
      number
      zipCode
    }
  }
`;
